import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  API,
  fileUpload,
  TableClasses,
  TableWrapClasses,
  TDClasses,
  THClasses,
  TRClasses,
} from "../../config";
import { Download, Home } from "lucide-react";
import { MonthPicker } from "../../components/ui/monthpicker";
import MainBody from "../../components/MainBody/MainBody";
import { useCallback } from "react";
import moment from "moment";
import { formatNumber, formatSubcontractorName } from "../../lib/Misc";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCaretDown,
  faCaretRight,
  faEdit,
} from "@fortawesome/free-solid-svg-icons";
import CustomTooltip from "../../components/CustomTooltip";
import BootstrapTable from "react-bootstrap-table-next";
import Pagination from "../../components/Pagination";
import { AnimatePresence, motion } from "framer-motion";
import Spin from "../../components/Spin";
import CommonFilters from "../../components/CommonFilters";
import DropDownButton from "../../components/DropDownButton";
import { useOrganization } from "../../lib/context/OrganisationContext";
import { Card, CardContent } from "../../components/ui/card";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../../components/ui/accordion";
import { ResponsiveDrawerForm } from "../../components/ResponsiveDrawerForm";
import { Formik } from "formik";
import { Label } from "../../components/ui/label";
import CustomLabelText from "../../components/CustomLabelText";
import { NumericFormat } from "react-number-format";
import { cn } from "../../lib/utils";
import { Button } from "../../components/ui/button";

const MonthlyBankReconciliation = ({
  trustId,
  setTrustId,
  isDesktop,
  org = false,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentDate = new Date();
  const [conditional, setConditional] = useState(false);

  const query = new URLSearchParams(location.search);
  const month = query.get("month")
    ? new Date(
        `${query.get("month")?.split("-")[1]}-${
          query.get("month")?.split("-")[0]
        }-01`
      )
    : new Date();

  const [selectedMonth, setSelectedMonth] = React.useState(
    month ? month : new Date()
  );

  const [vendorId, setVendorId] = useState();
  const [contactId, setContactId] = useState();

  const [monthlyData, setMontlyData] = useState();
  const [isDataLoading, setIsDataLoading] = useState(false);
  const [edit, setEdit] = useState();

  const toggleEditModal = () => {
    setEdit(!edit);
  };

  const updateMonthlyBalance = async (values) => {
    try {
      setIsDataLoading(true);
      values.amount = Number(`${values?.amount}`.replace(/,/g, ""));
      const reqObj = values;
      const formData = new FormData();
      formData.append("month", moment(selectedMonth)?.format("MM-YYYY"));
      formData.append("balance", reqObj["amount"] ? reqObj["amount"] : 0);
      formData.append(
        "trust_id",
        org && activeTrustId ? activeTrustId : trustId ? trustId : ""
      );

      const { data } = await fileUpload(
        `${API.CHANGE_MONTHLY_BANK_RECONCILIATION_BALANCE}`,
        formData
      );

      setIsDataLoading(false);
      if (data) {
        toggleEditModal();
        if (org) {
          fetchMonthlyBankReconciliationData(activeTrustId);
        } else {
          fetchMonthlyBankReconciliationData();
        }
      }
    } catch (error) {
      setIsDataLoading(false);
    }
  };

  const [expandAddReceipt, setExpandAddReceipt] = useState(false);
  const [addReceipts, setAddReceipts] = useState([]);
  const [limitAddReceipts, setLimitAddReceipts] = useState(10);
  const [pagingDataAddReceipts, setPagingDataAddReceipts] = useState({
    current: 1,
  });

  const [expandAddStatement, setExpandAddStatement] = useState(false);
  const [addStatements, setAddStatements] = useState([]);
  const [limitAddStatements, setLimitAddStatements] = useState(10);
  const [pagingDataAddStatements, setPagingDataAddStatements] = useState({
    current: 1,
  });

  const [expandDeductPayment, setExpandDeductPayment] = useState(false);
  const [deductPayments, setDeductPayments] = useState([]);
  const [limitDeductPayments, setLimitDeductPayments] = useState(10);
  const [pagingDataDeductPayments, setPagingDataDeductPayments] = useState({
    current: 1,
  });

  const [expandDeductStatement, setExpandDeductStatement] = useState(false);
  const [deductStatements, setDeductStatements] = useState([]);
  const [limitDeductStatements, setLimitDeductStatements] = useState(10);
  const [pagingDataDeductStatements, setPagingDataDeductStatements] = useState({
    current: 1,
  });

  const [expandAllReceipt, setExpandAllReceipt] = useState(false);
  const [allReceipts, setAllReceipts] = useState([]);
  const [limitAllReceipts, setLimitAllReceipts] = useState(10);
  const [pagingDataAllReceipts, setPagingDataAllReceipts] = useState({
    current: 1,
  });

  const [expandAllPayment, setExpandAllPayment] = useState(false);
  const [allPayments, setAllPayments] = useState([]);
  const [limitAllPayments, setLimitAllPayments] = useState(10);
  const [pagingDataAllPayments, setPagingDataAllPayments] = useState({
    current: 1,
  });

  const [isExpandDataLoading, setIsExpandDataLoading] = useState(false);

  const [activeTrustId, setActiveTrustId] = React.useState(null);
  const [trustListData, setTrustListData] = useState([]);
  const { organizationData } = useOrganization();

  const handleAccordionChange = async (value) => {
    if (!value) {
      setActiveTrustId(null);
      return;
    }
    setActiveTrustId(value);
  };

  const fetchTustMonthlyReportData = useCallback(async () => {
    try {
      setIsDataLoading(true);
      const formData = new FormData();
      if (trustId?.length > 0) {
        trustId?.map((item, index) =>
          formData.append(`trust_ids[${index}]`, item)
        );
      }

      formData.append(
        "organization_id",
        organizationData?.organizationId ? organizationData?.organizationId : ""
      );

      formData.append("type", "monthly-bank-reconciliation-report");
      formData.append("month", moment(selectedMonth).format("MM-YYYY"));

      const { data } = await fileUpload(
        `${API.ORG_GENERAL_LEDGER_REPORT}`,
        formData
      );
      setTrustListData(data?.data);
      let activetTust = data?.data?.filter((item) => item?.transactions === 1);

      if (activetTust?.[0]?.id !== undefined) {
        setActiveTrustId(activetTust?.[0]?.id);
      }
      setIsDataLoading(false);
    } catch (error) {
      setIsDataLoading(false);
    }
  }, [trustId, organizationData?.organizationId, selectedMonth]);

  useEffect(() => {
    if (org) {
      fetchTustMonthlyReportData();
    }
  }, [org, fetchTustMonthlyReportData]);

  function monthAddPadding(num, totalLength) {
    return String(num).padStart(totalLength, "0");
  }
  const lastDate = (date) => {
    var data = date.split("-");
    let lastMonthDate = new Date(data[1], data[0], 0);
    return (
      lastMonthDate.getDate() +
      "/" +
      monthAddPadding(lastMonthDate.getMonth() + 1, 2) +
      "/" +
      lastMonthDate.getFullYear()
    );
  };

  const handleExportReport = async (format, summary) => {
    setIsDataLoading(true);
    try {
      const formData = new FormData();
      if (org) {
        if (trustId?.length > 0) {
          trustId?.map((item, index) =>
            formData.append(`trust_ids[${index}]`, item)
          );
        }

        formData.append(
          "organization_id",
          organizationData?.organizationId
            ? organizationData?.organizationId
            : ""
        );
      } else if (!org) {
        formData.append(`trust_id`, trustId ? trustId : "");
      }
      if (vendorId?.length > 0) {
        vendorId?.map((item, index) =>
          formData.append(`vendor_ids[${index}]`, item)
        );
      }
      if (contactId?.length > 0) {
        contactId?.map((item, index) =>
          formData.append(`contact_ids[${index}]`, item)
        );
      }
      formData.append("format", format);
      formData.append("summary", summary);
      formData.append("month", moment(selectedMonth).format("MM-YYYY"));
      formData.append("export", 1);

      const { data } = await fileUpload(
        `${API.MONTHLY_BANK_RECONCILIATION_REPORT}`,
        formData
      );

      const export_report_path = data?.data?.file;

      if (export_report_path) {
        var a = document.createElement("a");
        a.href = export_report_path;
        var file = export_report_path.split("/");
        a.setAttribute(
          "download",
          file[file.length - 1] || "transactionsreport.pdf"
        );
        a.setAttribute("target", "_blank");
        document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
        a.click();
        a.remove();
        setIsDataLoading(false);
      }
    } catch (error) {
      setIsDataLoading(false);
    }
  };

  useEffect(() => {
    if (!org) {
      navigate(
        `?tab=monthly-bank-reconciliation&month=${moment(
          selectedMonth,
          "MM-YYYY"
        ).format("MM-YYYY")}`,
        { replace: true }
      );
    }
  }, [navigate, org, selectedMonth]);

  const fetchMonthlyBankReconciliationData = useCallback(
    async (activeTrustId) => {
      try {
        setIsDataLoading(true);
        const formData = new FormData();
        formData.append(
          `trust_id`,
          org && activeTrustId ? activeTrustId : trustId ? trustId : ""
        );
        if (vendorId?.length > 0) {
          vendorId?.map((item, index) =>
            formData.append(`vendor_ids[${index}]`, item)
          );
        }
        if (contactId?.length > 0) {
          contactId?.map((item, index) =>
            formData.append(`contact_ids[${index}]`, item)
          );
        }
        formData.append("month", moment(selectedMonth).format("MM-YYYY"));
        const { data } = await fileUpload(
          `${API.MONTHLY_BANK_RECONCILIATION_REPORT}`,
          formData
        );
        let monthlyData = data?.data;

        let sub_total =
          Number(
            monthlyData?.statement_balance ? monthlyData?.statement_balance : 0
          ) +
          Number(monthlyData?.transactionDepositNotStatement) +
          Number(monthlyData?.transactionWithdrawalStatements);

        let a_total =
          sub_total < 0
            ? sub_total +
              Number(
                Number(monthlyData?.transactionWithdrawalNotStatements) +
                  Number(monthlyData?.transactionDepositStatement)
              )
            : sub_total +
              Number(
                Number(monthlyData?.transactionWithdrawalNotStatements) +
                  Number(monthlyData?.transactionDepositStatement)
              ) *
                -1;

        let b_total =
          Number(
            Number(
              monthlyData?.openingBalance ? monthlyData?.openingBalance : 0
            )
          ) +
          Number(monthlyData?.allTransactionDeposits) +
          Number(Number(monthlyData?.allTransactionWithdrawalStatements) * -1);

        setMontlyData({
          monthlyData: monthlyData,
          sub_total: sub_total,
          a_total: a_total,
          b_total: b_total,
        });

        setIsDataLoading(false);
      } catch (error) {
        setIsDataLoading(false);
      }
    },
    [org, selectedMonth, trustId, vendorId, contactId]
  );

  useEffect(() => {
    if (org) {
      if (activeTrustId) {
        fetchMonthlyBankReconciliationData(activeTrustId);
      }
    } else if (!org) {
      fetchMonthlyBankReconciliationData();
    }
  }, [fetchMonthlyBankReconciliationData, activeTrustId, org]);

  const fetchMonthlyBankReconciliationReportEntries = useCallback(
    async (type, page = 1, limit = 10) => {
      try {
        setIsExpandDataLoading(true);
        const formData = new FormData();
        formData.append(
          "trust_id",
          org && activeTrustId ? activeTrustId : trustId ? trustId : ""
        );
        if (vendorId?.length > 0) {
          vendorId?.map((item, index) =>
            formData.append(`vendor_ids[${index}]`, item)
          );
        }
        if (contactId?.length > 0) {
          contactId?.map((item, index) =>
            formData.append(`contact_ids[${index}]`, item)
          );
        }
        formData.append("month", moment(selectedMonth)?.format("MM-YYYY"));
        formData.append("type", type);
        formData.append("page", page);
        formData.append("limit", limit);
        const { data } = await fileUpload(
          `${API.MONTHLY_BANK_RECONCILIATION_REPORT_ENTRIES}`,
          formData
        );
        if (data) {
          setIsExpandDataLoading(false);
          const { total, current_page, per_page, from, to } = data.data;
          if (type === "transactionDepositNotStatement") {
            setAddReceipts(data?.data.data);
            setPagingDataAddReceipts({
              total,
              current: current_page,
              defaultPageSize: per_page,
              from: from,
              to: to,
            });
          }

          if (type === "transactionWithdrawalStatements") {
            setAddStatements(data?.data.data);
            setPagingDataAddStatements({
              total,
              current: current_page,
              defaultPageSize: per_page,
              from: from,
              to: to,
            });
          }

          if (type === "transactionWithdrawalNotStatements") {
            setDeductPayments(data?.data.data);
            setPagingDataDeductPayments({
              total,
              current: current_page,
              defaultPageSize: per_page,
              from: from,
              to: to,
            });
          }

          if (type === "transactionDepositStatement") {
            setDeductStatements(data?.data.data);
            setPagingDataDeductStatements({
              total,
              current: current_page,
              defaultPageSize: per_page,
              from: from,
              to: to,
            });
          }

          if (type === "allTransactionDeposits") {
            setAllReceipts(data?.data.data);
            setPagingDataAllReceipts({
              total,
              current: current_page,
              defaultPageSize: per_page,
              from: from,
              to: to,
            });
          }

          if (type === "allTransactionWithdrawalStatements") {
            setAllPayments(data?.data.data);
            setPagingDataAllPayments({
              total,
              current: current_page,
              defaultPageSize: per_page,
              from: from,
              to: to,
            });
          }
        }
      } catch (error) {
        setIsExpandDataLoading(false);
      }
    },
    [activeTrustId, org, selectedMonth, trustId, vendorId, contactId]
  );

  // Deposits in Cashbook but NOT in bank statement (Start)

  const toggleExpandRowAddReceipt = (value) => {
    if (value) {
      setExpandAddReceipt(!expandAddReceipt);
      setExpandAddStatement(false);
      setExpandAllPayment(false);
      setExpandAllReceipt(false);
      setExpandDeductPayment(false);
      setExpandDeductStatement(false);
    }
  };

  const handleChangeAddReceipts = async (e) => {
    const value = e.target.value;
    setAddReceipts();
    setLimitAddReceipts(value);
    fetchMonthlyBankReconciliationReportEntries(
      "transactionDepositNotStatement",
      pagingDataAddReceipts?.current,
      value
    );
  };

  const onPageChangeAddReceipt = (page) => {
    setAddReceipts();
    setPagingDataAddReceipts({ ...pagingDataAddReceipts, current: page });
    fetchMonthlyBankReconciliationReportEntries(
      "transactionDepositNotStatement",
      page,
      limitAddReceipts
    );
  };

  const ExpandDataGenerator = (type, quantity) => {
    const items = [];
    if (expandAddStatement || expandDeductStatement) {
      for (let i = 0; i < quantity; i++) {
        items.push({
          key: type[i]?.id,
          transactionDate: type[i]?.transaction_date
            ? moment(type[i]?.transaction_date, "DD-MM-YYYY").format(
                "DD-MM-YYYY"
              )
            : "-",
          description: type[i]?.description ? type[i]?.description : "-",
          credit:
            type[i]?.base_type === 1 ? (
              <span className="rag-green">
                {"$" + formatNumber(Number(type[i]?.amount))}
              </span>
            ) : (
              "-"
            ),
          debit:
            type[i]?.base_type === 0 ? (
              <span className="rag-red">
                {"$" + formatNumber(Number(type[i]?.amount))}
              </span>
            ) : (
              "-"
            ),
          bank_transaction_source: type[i]?.source ? type[i]?.source : "-",

          archived: type[i]?.deleted_at ? (
            <CustomTooltip message={"Archived"}>
              <span>
                <span color={"red"} key={"red"}>
                  {String.fromCodePoint("0x0001F6AB")}
                </span>
              </span>
            </CustomTooltip>
          ) : (
            ""
          ),

          // action: "",
        });
      }
    } else {
      for (let i = 0; i < quantity; i++) {
        items.push({
          key: type[i]?.id,
          transaction_date: type[i]?.transaction_date
            ? type[i]?.transaction_date
            : "-",
          name: formatSubcontractorName(type[i]),
          email: type[i]?.email ? type[i]?.email : "-",
          account_name: type[i]?.account_name ? type[i]?.account_name : "-",
          account_number: type[i]?.account_number
            ? type[i]?.account_number
            : "-",
          amount: type[i]?.amount
            ? `$${formatNumber(Number(Number(type[i]?.amount).toFixed(2)))}`
            : "$0.00",
        });
      }
    }
    return items;
  };

  const expandAddReceiptData = ExpandDataGenerator(
    addReceipts,
    addReceipts?.length
  );

  // Deposits in Cashbook but NOT in bank statement (End)

  // Withdrawls on the bank statement that are NOT in Cashbook (Start)

  const toggleExpandRowAddStatement = (value) => {
    if (value) {
      setExpandAddReceipt(false);
      setExpandAddStatement(!expandAddStatement);
      setExpandAllPayment(false);
      setExpandAllReceipt(false);
      setExpandDeductPayment(false);
      setExpandDeductStatement(false);
    }
  };

  const handleChangeAddStatements = async (e) => {
    const value = e.target.value;
    setAddStatements();
    setLimitAddStatements(value);
    fetchMonthlyBankReconciliationReportEntries(
      "transactionWithdrawalStatements",
      1,
      value
    );
  };

  const onPageChangeAddStatement = (page) => {
    setAddStatements();
    setPagingDataAddStatements({ ...pagingDataAddStatements, current: page });
    fetchMonthlyBankReconciliationReportEntries(
      "transactionWithdrawalStatements",
      page,
      limitAddStatements
    );
  };

  const expandAddStatementData = ExpandDataGenerator(
    addStatements,
    addStatements?.length
  );

  // Withdrawls on the bank statement that are NOT in Cashbook (End)
  // Deduct: Withdrawls in the Cashbook but NOT in bank statement (Start)

  const toggleExpandRowDeductPayment = (value) => {
    if (value) {
      setExpandAddReceipt(false);
      setExpandAddStatement(false);
      setExpandAllPayment(false);
      setExpandAllReceipt(false);
      setExpandDeductPayment(!expandDeductPayment);
      setExpandDeductStatement(false);
    }
  };

  const handleChangeDeductPayments = async (e) => {
    const value = e.target.value;
    setDeductPayments();
    setLimitDeductPayments(value);
    fetchMonthlyBankReconciliationReportEntries(
      "transactionWithdrawalNotStatements",
      1,
      value
    );
  };

  const onPageChangeDeductPayment = (page) => {
    setDeductPayments();
    setPagingDataDeductPayments({ ...pagingDataDeductPayments, current: page });
    fetchMonthlyBankReconciliationReportEntries(
      "transactionWithdrawalNotStatements",
      page,
      limitDeductPayments
    );
  };

  const expandDeductPaymentData = ExpandDataGenerator(
    deductPayments,
    deductPayments?.length
  );

  // Deduct: Withdrawls in the Cashbook but NOT in bank statement (End)

  // Deduct: Deposits on the bank statement that are NOT in Cashbook (Start)

  const toggleExpandRowDeductStatement = (value) => {
    if (value) {
      setExpandAddReceipt(false);
      setExpandAddStatement(false);
      setExpandAllPayment(false);
      setExpandAllReceipt(false);
      setExpandDeductPayment(false);
      setExpandDeductStatement(!expandDeductStatement);
    }
  };

  const handleChangeDeductStatements = async (e) => {
    const value = e.target.value;
    setDeductStatements();
    setLimitDeductStatements(value);
    fetchMonthlyBankReconciliationReportEntries(
      "transactionDepositStatement",
      1,
      value
    );
  };

  const onPageChangeDeductStatement = (page) => {
    setDeductStatements();
    setPagingDataDeductStatements({
      ...pagingDataDeductStatements,
      current: page,
    });
    fetchMonthlyBankReconciliationReportEntries(
      "transactionDepositStatement",
      page,
      limitDeductStatements
    );
  };

  const expandDeductStatementData = ExpandDataGenerator(
    deductStatements,
    deductStatements?.length
  );

  // Deduct: Deposits on the bank statement that are NOT in Cashbook (End)

  // Add: All deposits recorded in the Cashbook for the month (Start)

  const toggleExpandRowAllReceipt = (value) => {
    if (value) {
      setExpandAddReceipt(false);
      setExpandAddStatement(false);
      setExpandAllPayment(false);
      setExpandAllReceipt(!expandAllReceipt);
      setExpandDeductPayment(false);
      setExpandDeductStatement(false);
    }
  };

  const handleChangeAllReceipts = async (e) => {
    const value = e.target.value;
    setAllReceipts();
    setLimitAllReceipts(value);
    fetchMonthlyBankReconciliationReportEntries(
      "allTransactionDeposits",
      1,
      value
    );
  };

  const onPageChangeAllReceipt = (page) => {
    setAllReceipts();
    setPagingDataAllReceipts({ ...pagingDataAllReceipts, current: page });
    fetchMonthlyBankReconciliationReportEntries(
      "allTransactionDeposits",
      page,
      limitAllReceipts
    );
  };

  const expandAllReceiptData = ExpandDataGenerator(
    allReceipts,
    allReceipts?.length
  );

  // Add: All deposits recorded in the Cashbook for the month (End)

  // Deduct: All withdrawls recorded in the Cashbook for the month (Start)

  const toggleExpandRowAllPayment = (value) => {
    if (value) {
      setExpandAddReceipt(false);
      setExpandAddStatement(false);
      setExpandAllPayment(!expandAllPayment);
      setExpandAllReceipt(false);
      setExpandDeductPayment(false);
      setExpandDeductStatement(false);
    }
  };

  const handleChangeAllPayments = async (e) => {
    const value = e.target.value;
    setAllPayments();
    setLimitAllPayments(value);
    fetchMonthlyBankReconciliationReportEntries(
      "allTransactionWithdrawalStatements",
      1,
      value
    );
  };

  const onPageChangeAllPayment = (page) => {
    setAllPayments();
    setPagingDataAllPayments({ ...pagingDataAllPayments, current: page });
    fetchMonthlyBankReconciliationReportEntries(
      "allTransactionWithdrawalStatements",
      page,
      limitAllPayments
    );
  };

  const expandAllPaymentData = ExpandDataGenerator(
    allPayments,
    allPayments?.length
  );

  // Deduct: All withdrawls recorded in the Cashbook for the month (End)

  const expandColumns = [
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "transaction_date",
      text: "Transaction Date",
      style: { width: "12%" },
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "name",
      text: "Name",
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "email",
      text: "Email",
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "account_name",
      text: "Account Name",
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "account_number",
      text: "Account Number",
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "amount",
      text: "Amount",
      style: { width: "12%" },
    },
  ];

  const expandColumns2 = [
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "transactionDate",
      text: "Date",
      sort: true,
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "description",
      text: "Description",
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "credit",
      text: "Credit",
      sort: true,
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "debit",
      text: "Debit",
      sort: true,
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "bank_transaction_source",
      text: "Bank Transaction Source",
    },
  ];

  useEffect(() => {
    if (expandAddReceipt) {
      fetchMonthlyBankReconciliationReportEntries(
        "transactionDepositNotStatement",
        1,
        limitAddReceipts
      );
    }
    if (expandAddStatement) {
      fetchMonthlyBankReconciliationReportEntries(
        "transactionWithdrawalStatements",
        1,
        limitAddStatements
      );
    }
    if (expandDeductPayment) {
      fetchMonthlyBankReconciliationReportEntries(
        "transactionWithdrawalNotStatements",
        1,
        limitDeductPayments
      );
    }
    if (expandDeductStatement) {
      fetchMonthlyBankReconciliationReportEntries(
        "transactionDepositStatement",
        1,
        limitDeductStatements
      );
    }
    if (expandAllReceipt) {
      fetchMonthlyBankReconciliationReportEntries(
        "allTransactionDeposits",
        1,
        limitAllReceipts
      );
    }
    if (expandAllPayment) {
      fetchMonthlyBankReconciliationReportEntries(
        "allTransactionWithdrawalStatements",
        1,
        limitAllPayments
      );
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    expandAddReceipt,
    expandAddStatement,
    expandDeductPayment,
    expandDeductStatement,
    expandAllReceipt,
    expandAllPayment,
    fetchMonthlyBankReconciliationReportEntries,
  ]);

  useEffect(() => {
    const formatValue = (value) =>
      value
        ? value > 0
          ? formatNumber(value)
          : `(${formatNumber(value * -1)})`
        : "0.00";

    const aFormatted = formatValue(monthlyData?.a_total);
    const bFormatted = formatValue(monthlyData?.b_total);
    const cFormatted = formatValue(
      Number(monthlyData?.monthlyData?.trialBalance)
    );

    const data = aFormatted === bFormatted && bFormatted === cFormatted;

    setConditional(data);
  }, [
    monthlyData?.a_total,
    monthlyData?.b_total,
    monthlyData?.monthlyData?.trialBalance,
  ]);

  return (
    <div className="relative">
      <MainBody
        search={false}
        innerBody={true}
        parentHeight={true}
        actionRight={isDesktop ? true : false}
        actionContent={
          <>
            <MonthPicker
              onMonthSelect={setSelectedMonth}
              selectedMonth={selectedMonth}
              variant="outline"
              align={isDesktop ? "end" : "start"}
              maxDate={new Date()}
            />

            {org && (
              <CommonFilters
                trust={org}
                trustId={trustId}
                multiTrust={org}
                setTrustId={setTrustId}
                vendor={false}
                setVendorId={setVendorId}
                vendorId={vendorId}
                multiVendor={true}
                contact={false}
                setContactId={setContactId}
                contactId={contactId}
                multiContact={true}
              />
            )}
            <DropDownButton
              items={[
                {
                  label: "Summary",
                  items: [
                    {
                      label: "PDF",
                      onClick: () => handleExportReport("pdf", 1),
                      disabled: isDataLoading,
                    },
                    {
                      label: "Excel",
                      onClick: () => handleExportReport("xlsx", 1),
                      disabled: isDataLoading,
                    },
                  ],
                },
                {
                  label: "Detailed",
                  items: [
                    {
                      label: "PDF",
                      onClick: () => handleExportReport("pdf", 0),
                      disabled: isDataLoading,
                    },
                    {
                      label: "Excel",
                      onClick: () => handleExportReport("xlsx", 0),
                      disabled: isDataLoading,
                    },
                  ],
                },
              ]}
              text={
                <div className="flex gap-2 items-center">
                  Export <Download size={18} />
                </div>
              }
            />
          </>
        }
        loading={isDataLoading}
      >
        {org && trustListData?.length > 0 ? (
          <>
            <Accordion
              type="single"
              collapsible
              value={activeTrustId}
              onValueChange={handleAccordionChange}
              className="w-full"
            >
              {trustListData.map((item) => {
                const trustLabel = item?.business_name
                  ? item?.business_name
                  : item?.first_name
                  ? item?.first_name + " " + item?.last_name
                  : item?.last_name;

                return (
                  <AccordionItem
                    key={item?.id}
                    value={item?.id}
                    className="border-none mb-2"
                  >
                    <AccordionTrigger className="text-base font-medium bg-webSecondary hover:bg-webSecondary text-white dark:bg-muted px-4 py-2 rounded-md dark:hover:bg-muted/70">
                      <div className="flex items-center justify-between w-full pr-3">
                        {trustLabel}
                        <div className="flex gap-3">
                          <div>
                            Opening Balance:{" "}
                            <span>
                              {item?.opening_balance
                                ? item?.opening_balance > 0
                                  ? `($${formatNumber(
                                      Number(item?.opening_balance)
                                    )})`
                                  : `$${formatNumber(
                                      Math.abs(Number(item?.opening_balance))
                                    )}`
                                : "$0.00"}
                            </span>
                          </div>
                          <div>
                            Closing Balance:{" "}
                            <span>
                              {item?.closing_balance
                                ? item?.closing_balance > 0
                                  ? `($${formatNumber(
                                      Number(item?.closing_balance)
                                    )})`
                                  : `$${formatNumber(
                                      Math.abs(Number(item?.closing_balance))
                                    )}`
                                : "$0.00"}
                            </span>
                          </div>
                        </div>
                      </div>
                    </AccordionTrigger>
                    <AccordionContent>
                      <div className="custom-table mt-2">
                        <div
                          className={
                            "table-body-class sm:max-h-[600px] max-h-screen rounded-md border"
                          }
                        >
                          <table className="w-full">
                            <thead>
                              <tr className={TRClasses}>
                                <th
                                  className={`${THClasses} text-center`}
                                  colSpan={5}
                                >
                                  {monthlyData?.monthlyData?.trust
                                    ?.business_name
                                    ? monthlyData?.monthlyData?.trust
                                        ?.business_name
                                    : monthlyData?.monthlyData?.trust
                                        ?.first_name
                                    ? monthlyData?.monthlyData?.trust
                                        ?.first_name +
                                      " " +
                                      monthlyData?.monthlyData?.trust?.last_name
                                    : monthlyData?.monthlyData?.trust
                                        ?.last_name}
                                </th>
                              </tr>
                              <tr className={TRClasses}>
                                <th
                                  className={`${THClasses} text-center bg-webSecondary`}
                                >
                                  Account Number
                                </th>
                                <th
                                  className={`${THClasses} text-center bg-webSecondary`}
                                >
                                  Account name
                                </th>
                                <th
                                  className={`${THClasses} text-center bg-webSecondary`}
                                >
                                  Date of reconcilation
                                </th>
                                <th
                                  className={`${THClasses} text-center bg-webSecondary`}
                                >
                                  End of month bank statement
                                </th>
                                <th
                                  className={`${THClasses} text-center bg-webSecondary`}
                                >
                                  End of month account balance($)
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr className={TRClasses}>
                                <td className={`${TDClasses} text-center`}>
                                  {monthlyData?.monthlyData?.trustBankDetails
                                    ?.account_number
                                    ? monthlyData?.monthlyData?.trustBankDetails
                                        ?.account_number
                                    : ""}
                                </td>
                                <td className={`${TDClasses} text-center`}>
                                  {monthlyData?.monthlyData?.trustBankDetails
                                    ?.account_name
                                    ? monthlyData?.monthlyData?.trustBankDetails
                                        ?.account_name
                                    : ""}
                                </td>
                                <td className={`${TDClasses} text-right`}>
                                  {currentDate
                                    ? currentDate.getDate() +
                                      "/" +
                                      monthAddPadding(
                                        currentDate.getMonth() + 1,
                                        2
                                      ) +
                                      "/" +
                                      currentDate.getFullYear()
                                    : ""}
                                </td>
                                <td className={`${TDClasses} text-right`}>
                                  {selectedMonth
                                    ? lastDate(
                                        moment(selectedMonth).format("MM-YYYY")
                                      )
                                    : ""}
                                </td>
                                <td className={`${TDClasses} text-right`}>
                                  <div className="flex items-center gap-1 w-full justify-end">
                                    {monthlyData?.monthlyData?.statement_balance
                                      ? monthlyData?.monthlyData
                                          ?.statement_balance > 0
                                        ? formatNumber(
                                            Number(
                                              monthlyData?.monthlyData
                                                ?.statement_balance
                                            )
                                          )
                                        : `(${formatNumber(
                                            Number(
                                              monthlyData?.monthlyData
                                                ?.statement_balance * -1
                                            )
                                          )})`
                                      : "0.00"}
                                    <span>
                                      <FontAwesomeIcon
                                        icon={faEdit}
                                        onClick={() => setEdit(true)}
                                      />
                                    </span>
                                  </div>
                                </td>
                              </tr>
                              <tr className={TRClasses}>
                                {" "}
                                <th
                                  className={`${THClasses} text-center`}
                                  colSpan={3}
                                >
                                  Reconciliation
                                </th>{" "}
                                <th
                                  className={`${THClasses} text-center`}
                                  colSpan={2}
                                >
                                  Value($)
                                </th>
                              </tr>
                              <tr className={TRClasses}>
                                <th
                                  className={`${THClasses} text-center bg-webSecondary`}
                                  colSpan={5}
                                >
                                  Bank Statement Reconciliation
                                </th>
                              </tr>
                              <tr className={TRClasses}>
                                {" "}
                                <td className={`${TDClasses}`} colSpan={3}>
                                  Account balance on{" "}
                                  {selectedMonth
                                    ? lastDate(
                                        moment(selectedMonth).format("MM-YYYY")
                                      )
                                    : ""}
                                </td>{" "}
                                <td
                                  className={`${TDClasses} text-right`}
                                  colSpan={2}
                                >
                                  {monthlyData?.monthlyData?.statement_balance
                                    ? monthlyData?.monthlyData
                                        ?.statement_balance > 0
                                      ? formatNumber(
                                          Number(
                                            monthlyData?.monthlyData
                                              ?.statement_balance
                                          )
                                        )
                                      : `(${formatNumber(
                                          Number(
                                            monthlyData?.monthlyData
                                              ?.statement_balance * -1
                                          )
                                        )})`
                                    : "0.00"}
                                </td>
                              </tr>
                              <tr className={TRClasses}>
                                {" "}
                                <td className={`${TDClasses}`} colSpan={3}>
                                  <div>
                                    <span
                                      className="cursor-pointer"
                                      onClick={() =>
                                        toggleExpandRowAddReceipt(
                                          monthlyData?.monthlyData
                                            ?.transactionDepositNotStatement
                                        )
                                      }
                                    >
                                      {expandAddReceipt ? (
                                        <FontAwesomeIcon icon={faCaretDown} />
                                      ) : (
                                        <FontAwesomeIcon icon={faCaretRight} />
                                      )}
                                    </span>
                                    <span
                                      style={{
                                        cursor: "pointer",
                                        marginLeft: "10px",
                                      }}
                                    >
                                      Add: Deposits in Cashbook but NOT in bank
                                      statement
                                    </span>
                                  </div>
                                </td>{" "}
                                <td
                                  className={`${TDClasses} text-right`}
                                  colSpan={2}
                                >
                                  {monthlyData?.monthlyData
                                    ?.transactionDepositNotStatement
                                    ? formatNumber(
                                        Number(
                                          monthlyData?.monthlyData
                                            ?.transactionDepositNotStatement
                                        )
                                      )
                                    : "0.00"}
                                </td>
                              </tr>
                              <AnimatePresence initial={false}>
                                {expandAddReceipt && (
                                  <tr className={TRClasses}>
                                    <td className={`${TDClasses}`} colSpan={5}>
                                      <motion.div
                                        key="expand-content"
                                        initial={{ height: 0, opacity: 0 }}
                                        animate={{ height: "auto", opacity: 1 }}
                                        exit={{ height: 0, opacity: 0 }}
                                        transition={{
                                          duration: 0.4,
                                          ease: "easeInOut",
                                        }}
                                        style={{
                                          overflow: "hidden",
                                          position: "relative",
                                        }}
                                      >
                                        {isExpandDataLoading && (
                                          <Spin expand={true} />
                                        )}
                                        <BootstrapTable
                                          keyField="key"
                                          remote
                                          data={expandAddReceiptData}
                                          columns={expandColumns}
                                          rowClasses={TRClasses}
                                          noDataIndication="No Data Found"
                                          classes={TableClasses}
                                          wrapperClasses={TableWrapClasses}
                                        />
                                        <Pagination
                                          total={pagingDataAddReceipts?.total}
                                          limit={parseInt(
                                            pagingDataAddReceipts?.defaultPageSize
                                          )}
                                          currentPage={
                                            pagingDataAddReceipts?.current
                                          }
                                          updateLimit={handleChangeAddReceipts}
                                          updatePage={onPageChangeAddReceipt}
                                          from={pagingDataAddReceipts?.from}
                                          to={pagingDataAddReceipts?.to}
                                        />
                                      </motion.div>
                                    </td>
                                  </tr>
                                )}
                              </AnimatePresence>

                              <tr className={TRClasses}>
                                {" "}
                                <td className={`${TDClasses}`} colSpan={3}>
                                  <div>
                                    <span
                                      className="cursor-pointer"
                                      onClick={() =>
                                        toggleExpandRowAddStatement(
                                          monthlyData?.monthlyData
                                            ?.transactionWithdrawalStatements
                                        )
                                      }
                                    >
                                      {expandAddStatement ? (
                                        <FontAwesomeIcon icon={faCaretDown} />
                                      ) : (
                                        <FontAwesomeIcon icon={faCaretRight} />
                                      )}
                                    </span>
                                    <span
                                      style={{
                                        cursor: "pointer",
                                        marginLeft: "10px",
                                      }}
                                    >
                                      Add: Withdrawls on the bank statement that
                                      are NOT in Cashbook
                                    </span>
                                  </div>
                                </td>{" "}
                                <td
                                  className={`${TDClasses} text-right`}
                                  colSpan={2}
                                >
                                  {monthlyData?.monthlyData
                                    ?.transactionWithdrawalStatements
                                    ? formatNumber(
                                        Number(
                                          monthlyData?.monthlyData
                                            ?.transactionWithdrawalStatements
                                        )
                                      )
                                    : "0.00"}
                                </td>
                              </tr>
                              <AnimatePresence initial={false}>
                                {expandAddStatement && (
                                  <tr className={TRClasses}>
                                    <td className={`${TDClasses}`} colSpan={5}>
                                      <motion.div
                                        key="expand-content2"
                                        initial={{ height: 0, opacity: 0 }}
                                        animate={{ height: "auto", opacity: 1 }}
                                        exit={{ height: 0, opacity: 0 }}
                                        transition={{
                                          duration: 0.4,
                                          ease: "easeInOut",
                                        }}
                                        style={{
                                          overflow: "hidden",
                                          position: "relative",
                                        }}
                                      >
                                        {isExpandDataLoading && (
                                          <Spin expand={true} />
                                        )}
                                        <BootstrapTable
                                          keyField="key"
                                          remote
                                          data={expandAddStatementData}
                                          columns={expandColumns2}
                                          rowClasses={TRClasses}
                                          noDataIndication="No Data Found"
                                          classes={TableClasses}
                                          wrapperClasses={TableWrapClasses}
                                        />
                                        <Pagination
                                          total={pagingDataAddStatements?.total}
                                          limit={parseInt(
                                            pagingDataAddStatements?.defaultPageSize
                                          )}
                                          currentPage={
                                            pagingDataAddStatements?.current
                                          }
                                          updateLimit={
                                            handleChangeAddStatements
                                          }
                                          updatePage={onPageChangeAddStatement}
                                          from={pagingDataAddStatements?.from}
                                          to={pagingDataAddStatements?.to}
                                        />
                                      </motion.div>
                                    </td>
                                  </tr>
                                )}
                              </AnimatePresence>

                              <tr className={`${TRClasses} bg-muted font-bold`}>
                                {" "}
                                <td className={`${TDClasses}`} colSpan={3}>
                                  Subtotal
                                </td>{" "}
                                <td
                                  className={`${TDClasses} text-right`}
                                  colSpan={2}
                                >
                                  {monthlyData?.sub_total
                                    ? monthlyData?.sub_total > 0
                                      ? formatNumber(
                                          Number(monthlyData?.sub_total)
                                        )
                                      : `(${formatNumber(
                                          Number(monthlyData?.sub_total * -1)
                                        )})`
                                    : "0.00"}
                                </td>
                              </tr>

                              <tr className={TRClasses}>
                                {" "}
                                <td className={`${TDClasses}`} colSpan={3}>
                                  <div>
                                    <span
                                      className="cursor-pointer"
                                      onClick={() =>
                                        toggleExpandRowDeductPayment(
                                          monthlyData?.monthlyData
                                            ?.transactionWithdrawalNotStatements
                                        )
                                      }
                                    >
                                      {expandDeductPayment ? (
                                        <FontAwesomeIcon icon={faCaretDown} />
                                      ) : (
                                        <FontAwesomeIcon icon={faCaretRight} />
                                      )}
                                    </span>
                                    <span
                                      style={{
                                        cursor: "pointer",
                                        marginLeft: "10px",
                                      }}
                                    >
                                      Deduct: Withdrawls in the Cashbook but NOT
                                      in bank statement
                                    </span>
                                  </div>
                                </td>{" "}
                                <td
                                  className={`${TDClasses} text-right`}
                                  colSpan={2}
                                >
                                  {monthlyData?.monthlyData
                                    ?.transactionWithdrawalNotStatements
                                    ? formatNumber(
                                        Number(
                                          monthlyData?.monthlyData
                                            ?.transactionWithdrawalNotStatements
                                        )
                                      )
                                    : "0.00"}
                                </td>
                              </tr>
                              <AnimatePresence initial={false}>
                                {expandDeductPayment && (
                                  <tr className={TRClasses}>
                                    <td className={`${TDClasses}`} colSpan={5}>
                                      <motion.div
                                        key="expand-content3"
                                        initial={{ height: 0, opacity: 0 }}
                                        animate={{ height: "auto", opacity: 1 }}
                                        exit={{ height: 0, opacity: 0 }}
                                        transition={{
                                          duration: 0.4,
                                          ease: "easeInOut",
                                        }}
                                        style={{
                                          overflow: "hidden",
                                          position: "relative",
                                        }}
                                      >
                                        {isExpandDataLoading && (
                                          <Spin expand={true} />
                                        )}
                                        <BootstrapTable
                                          keyField="key"
                                          remote
                                          data={expandDeductPaymentData}
                                          columns={expandColumns}
                                          rowClasses={TRClasses}
                                          noDataIndication="No Data Found"
                                          classes={TableClasses}
                                          wrapperClasses={TableWrapClasses}
                                        />
                                        <Pagination
                                          total={
                                            pagingDataDeductPayments?.total
                                          }
                                          limit={parseInt(
                                            pagingDataDeductPayments?.defaultPageSize
                                          )}
                                          currentPage={
                                            pagingDataDeductPayments?.current
                                          }
                                          updateLimit={
                                            handleChangeDeductPayments
                                          }
                                          updatePage={onPageChangeDeductPayment}
                                          from={pagingDataDeductPayments?.from}
                                          to={pagingDataDeductPayments?.to}
                                        />
                                      </motion.div>
                                    </td>
                                  </tr>
                                )}
                              </AnimatePresence>

                              <tr className={TRClasses}>
                                {" "}
                                <td className={`${TDClasses}`} colSpan={3}>
                                  <div>
                                    <span
                                      className="cursor-pointer"
                                      onClick={() =>
                                        toggleExpandRowDeductStatement(
                                          monthlyData?.monthlyData
                                            ?.transactionDepositStatement
                                        )
                                      }
                                    >
                                      {expandDeductStatement ? (
                                        <FontAwesomeIcon icon={faCaretDown} />
                                      ) : (
                                        <FontAwesomeIcon icon={faCaretRight} />
                                      )}
                                    </span>
                                    <span
                                      style={{
                                        cursor: "pointer",
                                        marginLeft: "10px",
                                      }}
                                    >
                                      Deduct: Deposits on the bank statement
                                      that are NOT in Cashbook
                                    </span>
                                  </div>
                                </td>{" "}
                                <td
                                  className={`${TDClasses} text-right`}
                                  colSpan={2}
                                >
                                  {monthlyData?.monthlyData
                                    ?.transactionDepositStatement
                                    ? formatNumber(
                                        Number(
                                          monthlyData?.monthlyData
                                            ?.transactionDepositStatement
                                        )
                                      )
                                    : "0.00"}
                                </td>
                              </tr>
                              <AnimatePresence initial={false}>
                                {expandDeductStatement && (
                                  <tr className={TRClasses}>
                                    <td className={`${TDClasses}`} colSpan={5}>
                                      <motion.div
                                        key="expand-content2"
                                        initial={{ height: 0, opacity: 0 }}
                                        animate={{ height: "auto", opacity: 1 }}
                                        exit={{ height: 0, opacity: 0 }}
                                        transition={{
                                          duration: 0.4,
                                          ease: "easeInOut",
                                        }}
                                        style={{
                                          overflow: "hidden",
                                          position: "relative",
                                        }}
                                      >
                                        {isExpandDataLoading && (
                                          <Spin expand={true} />
                                        )}
                                        <BootstrapTable
                                          keyField="key"
                                          remote
                                          data={expandDeductStatementData}
                                          columns={expandColumns2}
                                          rowClasses={TRClasses}
                                          noDataIndication="No Data Found"
                                          classes={TableClasses}
                                          wrapperClasses={TableWrapClasses}
                                        />
                                        <Pagination
                                          total={
                                            pagingDataDeductStatements?.total
                                          }
                                          limit={parseInt(
                                            pagingDataDeductStatements?.defaultPageSize
                                          )}
                                          currentPage={
                                            pagingDataDeductStatements?.current
                                          }
                                          updateLimit={
                                            handleChangeDeductStatements
                                          }
                                          updatePage={
                                            onPageChangeDeductStatement
                                          }
                                          from={
                                            pagingDataDeductStatements?.from
                                          }
                                          to={pagingDataDeductStatements?.to}
                                        />
                                      </motion.div>
                                    </td>
                                  </tr>
                                )}
                              </AnimatePresence>

                              <tr className={`${TRClasses} bg-muted font-bold`}>
                                {" "}
                                <td className={`${TDClasses}`} colSpan={3}>
                                  A: Expected balance on Cashbook
                                </td>{" "}
                                <td
                                  className={`${TDClasses} text-right`}
                                  colSpan={2}
                                >
                                  {monthlyData?.a_total
                                    ? monthlyData?.a_total > 0
                                      ? formatNumber(
                                          Number(monthlyData?.a_total)
                                        )
                                      : `(${formatNumber(
                                          Number(monthlyData?.a_total * -1)
                                        )})`
                                    : "0.00"}
                                </td>
                              </tr>

                              <tr className={TRClasses}>
                                <th
                                  className={`${THClasses} text-center bg-webSecondary`}
                                  colSpan={5}
                                >
                                  Ledger Reconciliation
                                </th>
                              </tr>

                              <tr className={TRClasses}>
                                {" "}
                                <td className={`${TDClasses}`} colSpan={3}>
                                  Balance of trust account at the start of the
                                  month, as shown in the Ledger
                                </td>{" "}
                                <td
                                  className={`${TDClasses} text-right`}
                                  colSpan={2}
                                >
                                  {monthlyData?.monthlyData?.openingBalance
                                    ? monthlyData?.monthlyData?.openingBalance >
                                      0
                                      ? formatNumber(
                                          Number(
                                            monthlyData?.monthlyData
                                              ?.openingBalance
                                          )
                                        )
                                      : `(${formatNumber(
                                          Number(
                                            monthlyData?.monthlyData
                                              ?.openingBalance * -1
                                          )
                                        )})`
                                    : "0.00"}
                                </td>
                              </tr>

                              <tr className={TRClasses}>
                                {" "}
                                <td className={`${TDClasses}`} colSpan={3}>
                                  <div>
                                    <span
                                      className="cursor-pointer"
                                      onClick={() =>
                                        toggleExpandRowAllReceipt(
                                          monthlyData?.monthlyData
                                            ?.allTransactionDeposits
                                        )
                                      }
                                    >
                                      {expandAllReceipt ? (
                                        <FontAwesomeIcon icon={faCaretDown} />
                                      ) : (
                                        <FontAwesomeIcon icon={faCaretRight} />
                                      )}
                                    </span>
                                    <span
                                      style={{
                                        cursor: "pointer",
                                        marginLeft: "10px",
                                      }}
                                    >
                                      Add: All deposits recorded in the Ledger
                                      for the month
                                    </span>
                                  </div>
                                </td>{" "}
                                <td
                                  className={`${TDClasses} text-right`}
                                  colSpan={2}
                                >
                                  {monthlyData?.monthlyData
                                    ?.allTransactionDeposits
                                    ? formatNumber(
                                        Number(
                                          monthlyData?.monthlyData
                                            ?.allTransactionDeposits
                                        )
                                      )
                                    : "0.00"}
                                </td>
                              </tr>
                              <AnimatePresence initial={false}>
                                {expandAllReceipt && (
                                  <tr className={TRClasses}>
                                    <td className={`${TDClasses}`} colSpan={5}>
                                      <motion.div
                                        key="expand-content3"
                                        initial={{ height: 0, opacity: 0 }}
                                        animate={{ height: "auto", opacity: 1 }}
                                        exit={{ height: 0, opacity: 0 }}
                                        transition={{
                                          duration: 0.4,
                                          ease: "easeInOut",
                                        }}
                                        style={{
                                          overflow: "hidden",
                                          position: "relative",
                                        }}
                                      >
                                        {isExpandDataLoading && (
                                          <Spin expand={true} />
                                        )}
                                        <BootstrapTable
                                          keyField="key"
                                          remote
                                          data={expandAllReceiptData}
                                          columns={expandColumns}
                                          rowClasses={TRClasses}
                                          noDataIndication="No Data Found"
                                          classes={TableClasses}
                                          wrapperClasses={TableWrapClasses}
                                        />
                                        <Pagination
                                          total={pagingDataAllReceipts?.total}
                                          limit={parseInt(
                                            pagingDataAllReceipts?.defaultPageSize
                                          )}
                                          currentPage={
                                            pagingDataAllReceipts?.current
                                          }
                                          updateLimit={handleChangeAllReceipts}
                                          updatePage={onPageChangeAllReceipt}
                                          from={pagingDataAllReceipts?.from}
                                          to={pagingDataAllReceipts?.to}
                                        />
                                      </motion.div>
                                    </td>
                                  </tr>
                                )}
                              </AnimatePresence>

                              <tr className={TRClasses}>
                                {" "}
                                <td className={`${TDClasses}`} colSpan={3}>
                                  <div>
                                    <span
                                      className="cursor-pointer"
                                      onClick={() =>
                                        toggleExpandRowAllPayment(
                                          monthlyData?.monthlyData
                                            ?.allTransactionWithdrawalStatements
                                        )
                                      }
                                    >
                                      {expandAllPayment ? (
                                        <FontAwesomeIcon icon={faCaretDown} />
                                      ) : (
                                        <FontAwesomeIcon icon={faCaretRight} />
                                      )}
                                    </span>
                                    <span
                                      style={{
                                        cursor: "pointer",
                                        marginLeft: "10px",
                                      }}
                                    >
                                      Deduct: All withdrawls recorded in the
                                      Ledger for the month
                                    </span>
                                  </div>
                                </td>{" "}
                                <td
                                  className={`${TDClasses} text-right`}
                                  colSpan={2}
                                >
                                  {monthlyData?.monthlyData
                                    ?.allTransactionWithdrawalStatements
                                    ? formatNumber(
                                        Number(
                                          monthlyData?.monthlyData
                                            ?.allTransactionWithdrawalStatements
                                        )
                                      )
                                    : "0.00"}
                                </td>
                              </tr>
                              <AnimatePresence initial={false}>
                                {expandAllPayment && (
                                  <tr className={TRClasses}>
                                    <td className={`${TDClasses}`} colSpan={5}>
                                      <motion.div
                                        key="expand-content2"
                                        initial={{ height: 0, opacity: 0 }}
                                        animate={{ height: "auto", opacity: 1 }}
                                        exit={{ height: 0, opacity: 0 }}
                                        transition={{
                                          duration: 0.4,
                                          ease: "easeInOut",
                                        }}
                                        style={{
                                          overflow: "hidden",
                                          position: "relative",
                                        }}
                                      >
                                        {isExpandDataLoading && (
                                          <Spin expand={true} />
                                        )}
                                        <BootstrapTable
                                          keyField="key"
                                          remote
                                          data={expandAllPaymentData}
                                          columns={expandColumns}
                                          rowClasses={TRClasses}
                                          noDataIndication="No Data Found"
                                          classes={TableClasses}
                                          wrapperClasses={TableWrapClasses}
                                        />
                                        <Pagination
                                          total={pagingDataAllPayments?.total}
                                          limit={parseInt(
                                            pagingDataAllPayments?.defaultPageSize
                                          )}
                                          currentPage={
                                            pagingDataAllPayments?.current
                                          }
                                          updateLimit={handleChangeAllPayments}
                                          updatePage={onPageChangeAllPayment}
                                          from={pagingDataAllPayments?.from}
                                          to={pagingDataAllPayments?.to}
                                        />
                                      </motion.div>
                                    </td>
                                  </tr>
                                )}
                              </AnimatePresence>

                              <tr className={`${TRClasses} bg-muted font-bold`}>
                                {" "}
                                <td className={`${TDClasses}`} colSpan={3}>
                                  B: Balance of the trust account at the end of
                                  the month, as shown in the Ledger
                                </td>{" "}
                                <td
                                  className={`${TDClasses} text-right`}
                                  colSpan={2}
                                >
                                  {monthlyData?.b_total
                                    ? monthlyData?.b_total > 0
                                      ? formatNumber(
                                          Number(monthlyData?.b_total)
                                        )
                                      : `(${formatNumber(
                                          Number(monthlyData?.b_total * -1)
                                        )})`
                                    : "0.00"}
                                </td>
                              </tr>

                              <tr className={TRClasses}>
                                <th
                                  className={`${THClasses} text-center bg-webSecondary`}
                                  colSpan={5}
                                >
                                  Trust Account Ledger Trial Balance
                                </th>
                              </tr>

                              <tr className={`${TRClasses} bg-muted font-bold`}>
                                {" "}
                                <td className={`${TDClasses}`} colSpan={3}>
                                  C: Total balance held from the trust account
                                  ledger trial balance for the month
                                </td>{" "}
                                <td
                                  className={`${TDClasses} text-right`}
                                  colSpan={2}
                                >
                                  {monthlyData?.monthlyData?.trialBalance
                                    ? monthlyData?.monthlyData?.trialBalance > 0
                                      ? formatNumber(
                                          Number(
                                            monthlyData?.monthlyData
                                              ?.trialBalance
                                          )
                                        )
                                      : `(${formatNumber(
                                          Number(
                                            monthlyData?.monthlyData
                                              ?.trialBalance * -1
                                          )
                                        )})`
                                    : "0.00"}
                                </td>
                              </tr>
                              <tr
                                className={`${TRClasses} ${
                                  conditional ? "" : "border-b-0"
                                }`}
                              >
                                <th
                                  className={`${THClasses} text-center bg-webSecondary`}
                                  colSpan={5}
                                >
                                  A=B=C means the account is reconciled
                                </th>
                              </tr>
                              {conditional && (
                                <tr className={`${TRClasses} border-b-0`}>
                                  <th
                                    className={`${THClasses} text-center !bg-[#E0FBE2] !text-[#0da500]`}
                                    colSpan={5}
                                  >
                                    Great job! Your monthly bank reconciliation
                                    is now completed.
                                  </th>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </AccordionContent>
                  </AccordionItem>
                );
              })}
            </Accordion>
          </>
        ) : !org ? (
          <div className="custom-table">
            <div
              className={
                "table-body-class sm:max-h-[670px] max-h-screen rounded-md border"
              }
            >
              <table className="w-full">
                <thead>
                  <tr className={TRClasses}>
                    <th className={`${THClasses} text-center`} colSpan={5}>
                      {monthlyData?.monthlyData?.trust?.business_name
                        ? monthlyData?.monthlyData?.trust?.business_name
                        : monthlyData?.monthlyData?.trust?.first_name
                        ? monthlyData?.monthlyData?.trust?.first_name +
                          " " +
                          monthlyData?.monthlyData?.trust?.last_name
                        : monthlyData?.monthlyData?.trust?.last_name}
                    </th>
                  </tr>
                  <tr className={TRClasses}>
                    <th className={`${THClasses} text-center bg-webSecondary`}>
                      Account Number
                    </th>
                    <th className={`${THClasses} text-center bg-webSecondary`}>
                      Account name
                    </th>
                    <th className={`${THClasses} text-center bg-webSecondary`}>
                      Date of reconcilation
                    </th>
                    <th className={`${THClasses} text-center bg-webSecondary`}>
                      End of month bank statement
                    </th>
                    <th className={`${THClasses} text-center bg-webSecondary`}>
                      End of month account balance($)
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr className={TRClasses}>
                    <td className={`${TDClasses} text-center`}>
                      {monthlyData?.monthlyData?.trustBankDetails
                        ?.account_number
                        ? monthlyData?.monthlyData?.trustBankDetails
                            ?.account_number
                        : ""}
                    </td>
                    <td className={`${TDClasses} text-center`}>
                      {monthlyData?.monthlyData?.trustBankDetails?.account_name
                        ? monthlyData?.monthlyData?.trustBankDetails
                            ?.account_name
                        : ""}
                    </td>
                    <td className={`${TDClasses} text-right`}>
                      {currentDate
                        ? currentDate.getDate() +
                          "/" +
                          monthAddPadding(currentDate.getMonth() + 1, 2) +
                          "/" +
                          currentDate.getFullYear()
                        : ""}
                    </td>
                    <td className={`${TDClasses} text-right`}>
                      {selectedMonth
                        ? lastDate(moment(selectedMonth).format("MM-YYYY"))
                        : ""}
                    </td>
                    <td className={`${TDClasses} text-right`}>
                      <div className="flex items-center gap-1 w-full justify-end">
                        {monthlyData?.monthlyData?.statement_balance
                          ? monthlyData?.monthlyData?.statement_balance > 0
                            ? formatNumber(
                                Number(
                                  monthlyData?.monthlyData?.statement_balance
                                )
                              )
                            : `(${formatNumber(
                                Number(
                                  monthlyData?.monthlyData?.statement_balance *
                                    -1
                                )
                              )})`
                          : "0.00"}
                        <span>
                          <FontAwesomeIcon
                            icon={faEdit}
                            onClick={() => setEdit(true)}
                          />
                        </span>
                      </div>
                    </td>
                  </tr>
                  <tr className={TRClasses}>
                    {" "}
                    <th className={`${THClasses} text-center`} colSpan={3}>
                      Reconciliation
                    </th>{" "}
                    <th className={`${THClasses} text-center`} colSpan={2}>
                      Value($)
                    </th>
                  </tr>
                  <tr className={TRClasses}>
                    <th
                      className={`${THClasses} text-center bg-webSecondary`}
                      colSpan={5}
                    >
                      Bank Statement Reconciliation
                    </th>
                  </tr>
                  <tr className={TRClasses}>
                    {" "}
                    <td className={`${TDClasses}`} colSpan={3}>
                      Account balance on{" "}
                      {selectedMonth
                        ? lastDate(moment(selectedMonth).format("MM-YYYY"))
                        : ""}
                    </td>{" "}
                    <td className={`${TDClasses} text-right`} colSpan={2}>
                      {monthlyData?.monthlyData?.statement_balance
                        ? monthlyData?.monthlyData?.statement_balance > 0
                          ? formatNumber(
                              Number(
                                monthlyData?.monthlyData?.statement_balance
                              )
                            )
                          : `(${formatNumber(
                              Number(
                                monthlyData?.monthlyData?.statement_balance * -1
                              )
                            )})`
                        : "0.00"}
                    </td>
                  </tr>
                  <tr className={TRClasses}>
                    {" "}
                    <td className={`${TDClasses}`} colSpan={3}>
                      <div>
                        <span
                          className="cursor-pointer"
                          onClick={() =>
                            toggleExpandRowAddReceipt(
                              monthlyData?.monthlyData
                                ?.transactionDepositNotStatement
                            )
                          }
                        >
                          {expandAddReceipt ? (
                            <FontAwesomeIcon icon={faCaretDown} />
                          ) : (
                            <FontAwesomeIcon icon={faCaretRight} />
                          )}
                        </span>
                        <span style={{ cursor: "pointer", marginLeft: "10px" }}>
                          Add: Deposits in Cashbook but NOT in bank statement
                        </span>
                      </div>
                    </td>{" "}
                    <td className={`${TDClasses} text-right`} colSpan={2}>
                      {monthlyData?.monthlyData?.transactionDepositNotStatement
                        ? formatNumber(
                            Number(
                              monthlyData?.monthlyData
                                ?.transactionDepositNotStatement
                            )
                          )
                        : "0.00"}
                    </td>
                  </tr>
                  <AnimatePresence initial={false}>
                    {expandAddReceipt && (
                      <tr className={TRClasses}>
                        <td className={`${TDClasses}`} colSpan={5}>
                          <motion.div
                            key="expand-content"
                            initial={{ height: 0, opacity: 0 }}
                            animate={{ height: "auto", opacity: 1 }}
                            exit={{ height: 0, opacity: 0 }}
                            transition={{ duration: 0.4, ease: "easeInOut" }}
                            style={{ overflow: "hidden", position: "relative" }}
                          >
                            {isExpandDataLoading && <Spin expand={true} />}
                            <BootstrapTable
                              keyField="key"
                              remote
                              data={expandAddReceiptData}
                              columns={expandColumns}
                              rowClasses={TRClasses}
                              noDataIndication="No Data Found"
                              classes={TableClasses}
                              wrapperClasses={TableWrapClasses}
                            />
                            <Pagination
                              total={pagingDataAddReceipts?.total}
                              limit={parseInt(
                                pagingDataAddReceipts?.defaultPageSize
                              )}
                              currentPage={pagingDataAddReceipts?.current}
                              updateLimit={handleChangeAddReceipts}
                              updatePage={onPageChangeAddReceipt}
                              from={pagingDataAddReceipts?.from}
                              to={pagingDataAddReceipts?.to}
                            />
                          </motion.div>
                        </td>
                      </tr>
                    )}
                  </AnimatePresence>

                  <tr className={TRClasses}>
                    {" "}
                    <td className={`${TDClasses}`} colSpan={3}>
                      <div>
                        <span
                          className="cursor-pointer"
                          onClick={() =>
                            toggleExpandRowAddStatement(
                              monthlyData?.monthlyData
                                ?.transactionWithdrawalStatements
                            )
                          }
                        >
                          {expandAddStatement ? (
                            <FontAwesomeIcon icon={faCaretDown} />
                          ) : (
                            <FontAwesomeIcon icon={faCaretRight} />
                          )}
                        </span>
                        <span style={{ cursor: "pointer", marginLeft: "10px" }}>
                          Add: Withdrawls on the bank statement that are NOT in
                          Cashbook
                        </span>
                      </div>
                    </td>{" "}
                    <td className={`${TDClasses} text-right`} colSpan={2}>
                      {monthlyData?.monthlyData?.transactionWithdrawalStatements
                        ? formatNumber(
                            Number(
                              monthlyData?.monthlyData
                                ?.transactionWithdrawalStatements
                            )
                          )
                        : "0.00"}
                    </td>
                  </tr>
                  <AnimatePresence initial={false}>
                    {expandAddStatement && (
                      <tr className={TRClasses}>
                        <td className={`${TDClasses}`} colSpan={5}>
                          <motion.div
                            key="expand-content2"
                            initial={{ height: 0, opacity: 0 }}
                            animate={{ height: "auto", opacity: 1 }}
                            exit={{ height: 0, opacity: 0 }}
                            transition={{ duration: 0.4, ease: "easeInOut" }}
                            style={{ overflow: "hidden", position: "relative" }}
                          >
                            {isExpandDataLoading && <Spin expand={true} />}
                            <BootstrapTable
                              keyField="key"
                              remote
                              data={expandAddStatementData}
                              columns={expandColumns2}
                              rowClasses={TRClasses}
                              noDataIndication="No Data Found"
                              classes={TableClasses}
                              wrapperClasses={TableWrapClasses}
                            />
                            <Pagination
                              total={pagingDataAddStatements?.total}
                              limit={parseInt(
                                pagingDataAddStatements?.defaultPageSize
                              )}
                              currentPage={pagingDataAddStatements?.current}
                              updateLimit={handleChangeAddStatements}
                              updatePage={onPageChangeAddStatement}
                              from={pagingDataAddStatements?.from}
                              to={pagingDataAddStatements?.to}
                            />
                          </motion.div>
                        </td>
                      </tr>
                    )}
                  </AnimatePresence>

                  <tr className={`${TRClasses} bg-muted font-bold`}>
                    {" "}
                    <td className={`${TDClasses}`} colSpan={3}>
                      Subtotal
                    </td>{" "}
                    <td className={`${TDClasses} text-right`} colSpan={2}>
                      {monthlyData?.sub_total
                        ? monthlyData?.sub_total > 0
                          ? formatNumber(Number(monthlyData?.sub_total))
                          : `(${formatNumber(
                              Number(monthlyData?.sub_total * -1)
                            )})`
                        : "0.00"}
                    </td>
                  </tr>

                  <tr className={TRClasses}>
                    {" "}
                    <td className={`${TDClasses}`} colSpan={3}>
                      <div>
                        <span
                          className="cursor-pointer"
                          onClick={() =>
                            toggleExpandRowDeductPayment(
                              monthlyData?.monthlyData
                                ?.transactionWithdrawalNotStatements
                            )
                          }
                        >
                          {expandDeductPayment ? (
                            <FontAwesomeIcon icon={faCaretDown} />
                          ) : (
                            <FontAwesomeIcon icon={faCaretRight} />
                          )}
                        </span>
                        <span style={{ cursor: "pointer", marginLeft: "10px" }}>
                          Deduct: Withdrawls in the Cashbook but NOT in bank
                          statement
                        </span>
                      </div>
                    </td>{" "}
                    <td className={`${TDClasses} text-right`} colSpan={2}>
                      {monthlyData?.monthlyData
                        ?.transactionWithdrawalNotStatements
                        ? formatNumber(
                            Number(
                              monthlyData?.monthlyData
                                ?.transactionWithdrawalNotStatements
                            )
                          )
                        : "0.00"}
                    </td>
                  </tr>
                  <AnimatePresence initial={false}>
                    {expandDeductPayment && (
                      <tr className={TRClasses}>
                        <td className={`${TDClasses}`} colSpan={5}>
                          <motion.div
                            key="expand-content3"
                            initial={{ height: 0, opacity: 0 }}
                            animate={{ height: "auto", opacity: 1 }}
                            exit={{ height: 0, opacity: 0 }}
                            transition={{ duration: 0.4, ease: "easeInOut" }}
                            style={{ overflow: "hidden", position: "relative" }}
                          >
                            {isExpandDataLoading && <Spin expand={true} />}
                            <BootstrapTable
                              keyField="key"
                              remote
                              data={expandDeductPaymentData}
                              columns={expandColumns}
                              rowClasses={TRClasses}
                              noDataIndication="No Data Found"
                              classes={TableClasses}
                              wrapperClasses={TableWrapClasses}
                            />
                            <Pagination
                              total={pagingDataDeductPayments?.total}
                              limit={parseInt(
                                pagingDataDeductPayments?.defaultPageSize
                              )}
                              currentPage={pagingDataDeductPayments?.current}
                              updateLimit={handleChangeDeductPayments}
                              updatePage={onPageChangeDeductPayment}
                              from={pagingDataDeductPayments?.from}
                              to={pagingDataDeductPayments?.to}
                            />
                          </motion.div>
                        </td>
                      </tr>
                    )}
                  </AnimatePresence>

                  <tr className={TRClasses}>
                    {" "}
                    <td className={`${TDClasses}`} colSpan={3}>
                      <div>
                        <span
                          className="cursor-pointer"
                          onClick={() =>
                            toggleExpandRowDeductStatement(
                              monthlyData?.monthlyData
                                ?.transactionDepositStatement
                            )
                          }
                        >
                          {expandDeductStatement ? (
                            <FontAwesomeIcon icon={faCaretDown} />
                          ) : (
                            <FontAwesomeIcon icon={faCaretRight} />
                          )}
                        </span>
                        <span style={{ cursor: "pointer", marginLeft: "10px" }}>
                          Deduct: Deposits on the bank statement that are NOT in
                          Cashbook
                        </span>
                      </div>
                    </td>{" "}
                    <td className={`${TDClasses} text-right`} colSpan={2}>
                      {monthlyData?.monthlyData?.transactionDepositStatement
                        ? formatNumber(
                            Number(
                              monthlyData?.monthlyData
                                ?.transactionDepositStatement
                            )
                          )
                        : "0.00"}
                    </td>
                  </tr>
                  <AnimatePresence initial={false}>
                    {expandDeductStatement && (
                      <tr className={TRClasses}>
                        <td className={`${TDClasses}`} colSpan={5}>
                          <motion.div
                            key="expand-content2"
                            initial={{ height: 0, opacity: 0 }}
                            animate={{ height: "auto", opacity: 1 }}
                            exit={{ height: 0, opacity: 0 }}
                            transition={{ duration: 0.4, ease: "easeInOut" }}
                            style={{ overflow: "hidden", position: "relative" }}
                          >
                            {isExpandDataLoading && <Spin expand={true} />}
                            <BootstrapTable
                              keyField="key"
                              remote
                              data={expandDeductStatementData}
                              columns={expandColumns2}
                              rowClasses={TRClasses}
                              noDataIndication="No Data Found"
                              classes={TableClasses}
                              wrapperClasses={TableWrapClasses}
                            />
                            <Pagination
                              total={pagingDataDeductStatements?.total}
                              limit={parseInt(
                                pagingDataDeductStatements?.defaultPageSize
                              )}
                              currentPage={pagingDataDeductStatements?.current}
                              updateLimit={handleChangeDeductStatements}
                              updatePage={onPageChangeDeductStatement}
                              from={pagingDataDeductStatements?.from}
                              to={pagingDataDeductStatements?.to}
                            />
                          </motion.div>
                        </td>
                      </tr>
                    )}
                  </AnimatePresence>

                  <tr className={`${TRClasses} bg-muted font-bold`}>
                    {" "}
                    <td className={`${TDClasses}`} colSpan={3}>
                      A: Expected balance on Cashbook
                    </td>{" "}
                    <td className={`${TDClasses} text-right`} colSpan={2}>
                      {monthlyData?.a_total
                        ? monthlyData?.a_total > 0
                          ? formatNumber(Number(monthlyData?.a_total))
                          : `(${formatNumber(
                              Number(monthlyData?.a_total * -1)
                            )})`
                        : "0.00"}
                    </td>
                  </tr>

                  <tr className={TRClasses}>
                    <th
                      className={`${THClasses} text-center bg-webSecondary`}
                      colSpan={5}
                    >
                      Ledger Reconciliation
                    </th>
                  </tr>

                  <tr className={TRClasses}>
                    {" "}
                    <td className={`${TDClasses}`} colSpan={3}>
                      Balance of trust account at the start of the month, as
                      shown in the Ledger
                    </td>{" "}
                    <td className={`${TDClasses} text-right`} colSpan={2}>
                      {monthlyData?.monthlyData?.openingBalance
                        ? monthlyData?.monthlyData?.openingBalance > 0
                          ? formatNumber(
                              Number(monthlyData?.monthlyData?.openingBalance)
                            )
                          : `(${formatNumber(
                              Number(
                                monthlyData?.monthlyData?.openingBalance * -1
                              )
                            )})`
                        : "0.00"}
                    </td>
                  </tr>

                  <tr className={TRClasses}>
                    {" "}
                    <td className={`${TDClasses}`} colSpan={3}>
                      <div>
                        <span
                          className="cursor-pointer"
                          onClick={() =>
                            toggleExpandRowAllReceipt(
                              monthlyData?.monthlyData?.allTransactionDeposits
                            )
                          }
                        >
                          {expandAllReceipt ? (
                            <FontAwesomeIcon icon={faCaretDown} />
                          ) : (
                            <FontAwesomeIcon icon={faCaretRight} />
                          )}
                        </span>
                        <span style={{ cursor: "pointer", marginLeft: "10px" }}>
                          Add: All deposits recorded in the Ledger for the month
                        </span>
                      </div>
                    </td>{" "}
                    <td className={`${TDClasses} text-right`} colSpan={2}>
                      {monthlyData?.monthlyData?.allTransactionDeposits
                        ? formatNumber(
                            Number(
                              monthlyData?.monthlyData?.allTransactionDeposits
                            )
                          )
                        : "0.00"}
                    </td>
                  </tr>
                  <AnimatePresence initial={false}>
                    {expandAllReceipt && (
                      <tr className={TRClasses}>
                        <td className={`${TDClasses}`} colSpan={5}>
                          <motion.div
                            key="expand-content3"
                            initial={{ height: 0, opacity: 0 }}
                            animate={{ height: "auto", opacity: 1 }}
                            exit={{ height: 0, opacity: 0 }}
                            transition={{ duration: 0.4, ease: "easeInOut" }}
                            style={{ overflow: "hidden", position: "relative" }}
                          >
                            {isExpandDataLoading && <Spin expand={true} />}
                            <BootstrapTable
                              keyField="key"
                              remote
                              data={expandAllReceiptData}
                              columns={expandColumns}
                              rowClasses={TRClasses}
                              noDataIndication="No Data Found"
                              classes={TableClasses}
                              wrapperClasses={TableWrapClasses}
                            />
                            <Pagination
                              total={pagingDataAllReceipts?.total}
                              limit={parseInt(
                                pagingDataAllReceipts?.defaultPageSize
                              )}
                              currentPage={pagingDataAllReceipts?.current}
                              updateLimit={handleChangeAllReceipts}
                              updatePage={onPageChangeAllReceipt}
                              from={pagingDataAllReceipts?.from}
                              to={pagingDataAllReceipts?.to}
                            />
                          </motion.div>
                        </td>
                      </tr>
                    )}
                  </AnimatePresence>

                  <tr className={TRClasses}>
                    {" "}
                    <td className={`${TDClasses}`} colSpan={3}>
                      <div>
                        <span
                          className="cursor-pointer"
                          onClick={() =>
                            toggleExpandRowAllPayment(
                              monthlyData?.monthlyData
                                ?.allTransactionWithdrawalStatements
                            )
                          }
                        >
                          {expandAllPayment ? (
                            <FontAwesomeIcon icon={faCaretDown} />
                          ) : (
                            <FontAwesomeIcon icon={faCaretRight} />
                          )}
                        </span>
                        <span style={{ cursor: "pointer", marginLeft: "10px" }}>
                          Deduct: All withdrawls recorded in the Ledger for the
                          month
                        </span>
                      </div>
                    </td>{" "}
                    <td className={`${TDClasses} text-right`} colSpan={2}>
                      {monthlyData?.monthlyData
                        ?.allTransactionWithdrawalStatements
                        ? formatNumber(
                            Number(
                              monthlyData?.monthlyData
                                ?.allTransactionWithdrawalStatements
                            )
                          )
                        : "0.00"}
                    </td>
                  </tr>
                  <AnimatePresence initial={false}>
                    {expandAllPayment && (
                      <tr className={TRClasses}>
                        <td className={`${TDClasses}`} colSpan={5}>
                          <motion.div
                            key="expand-content2"
                            initial={{ height: 0, opacity: 0 }}
                            animate={{ height: "auto", opacity: 1 }}
                            exit={{ height: 0, opacity: 0 }}
                            transition={{ duration: 0.4, ease: "easeInOut" }}
                            style={{ overflow: "hidden", position: "relative" }}
                          >
                            {isExpandDataLoading && <Spin expand={true} />}
                            <BootstrapTable
                              keyField="key"
                              remote
                              data={expandAllPaymentData}
                              columns={expandColumns}
                              rowClasses={TRClasses}
                              noDataIndication="No Data Found"
                              classes={TableClasses}
                              wrapperClasses={TableWrapClasses}
                            />
                            <Pagination
                              total={pagingDataAllPayments?.total}
                              limit={parseInt(
                                pagingDataAllPayments?.defaultPageSize
                              )}
                              currentPage={pagingDataAllPayments?.current}
                              updateLimit={handleChangeAllPayments}
                              updatePage={onPageChangeAllPayment}
                              from={pagingDataAllPayments?.from}
                              to={pagingDataAllPayments?.to}
                            />
                          </motion.div>
                        </td>
                      </tr>
                    )}
                  </AnimatePresence>

                  <tr className={`${TRClasses} bg-muted font-bold`}>
                    {" "}
                    <td className={`${TDClasses}`} colSpan={3}>
                      B: Balance of the trust account at the end of the month,
                      as shown in the Ledger
                    </td>{" "}
                    <td className={`${TDClasses} text-right`} colSpan={2}>
                      {monthlyData?.b_total
                        ? monthlyData?.b_total > 0
                          ? formatNumber(Number(monthlyData?.b_total))
                          : `(${formatNumber(
                              Number(monthlyData?.b_total * -1)
                            )})`
                        : "0.00"}
                    </td>
                  </tr>

                  <tr className={TRClasses}>
                    <th
                      className={`${THClasses} text-center bg-webSecondary`}
                      colSpan={5}
                    >
                      Trust Account Ledger Trial Balance
                    </th>
                  </tr>

                  <tr className={`${TRClasses} bg-muted font-bold`}>
                    {" "}
                    <td className={`${TDClasses}`} colSpan={3}>
                      C: Total balance held from the trust account ledger trial
                      balance for the month
                    </td>{" "}
                    <td className={`${TDClasses} text-right`} colSpan={2}>
                      {monthlyData?.monthlyData?.trialBalance
                        ? monthlyData?.monthlyData?.trialBalance > 0
                          ? formatNumber(
                              Number(monthlyData?.monthlyData?.trialBalance)
                            )
                          : `(${formatNumber(
                              Number(
                                monthlyData?.monthlyData?.trialBalance * -1
                              )
                            )})`
                        : "0.00"}
                    </td>
                  </tr>
                  <tr
                    className={`${TRClasses} ${
                      conditional ? "" : "border-b-0"
                    }`}
                  >
                    <th
                      className={`${THClasses} text-center bg-webSecondary`}
                      colSpan={5}
                    >
                      A=B=C means the account is reconciled
                    </th>
                  </tr>
                  {conditional && (
                    <tr className={`${TRClasses} border-b-0`}>
                      <th
                        className={`${THClasses} text-center !bg-[#E0FBE2] !text-[#0da500]`}
                        colSpan={5}
                      >
                        Great job! Your monthly bank reconciliation is now
                        completed.
                      </th>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        ) : (
          <>
            <div className="flex h-full items-center justify-center p-4">
              <Card className="max-w-md w-full shadow-lg text-center">
                <CardContent className="flex flex-col items-center gap-4 py-10">
                  <Home className="h-12 w-12 text-webPrimary" />
                  <h2 className="text-2xl font-semibold ">
                    Please Select Trust{" "}
                  </h2>
                  <p>To get Report Data.</p>
                </CardContent>
              </Card>
            </div>
          </>
        )}
        <ResponsiveDrawerForm
          description={""}
          title={"Edit Balance"}
          handleOpen={() => {}}
          handleClose={() => {}}
          buttonText={""}
          className={"sm:max-w-1/2"}
          buttonClassName={"h-8 max-w-8 rounded-lg p-[5px]"}
          setOpen={setEdit}
          open={edit}
          write={true}
          popupType={"reports"}
        >
          <Formik
            initialValues={{
              amount: monthlyData?.monthlyData?.statement_balance
                ? monthlyData?.monthlyData?.statement_balance
                : "0.00",
            }}
            name="supplierForm"
            enableReinitialize={true}
            onSubmit={(values) => {
              updateMonthlyBalance(values);
            }}
            validateOnBlur={true}
            validateOnChange={true}
          >
            {({
              values,
              setErrors,
              errors,
              handleChange,
              handleBlur,
              handleSubmit,
              setFieldValue,
            }) => {
              return (
                <>
                  {isDataLoading && <Spin expand={true} fullscreen={true}/>}

                  <form
                    onSubmit={handleSubmit}
                    noValidate
                    className="entry-section"
                  >
                    <div className="form-box">
                      <div className="grid gap-2">
                        <Label htmlFor="amount">
                          <CustomLabelText
                            required={true}
                            labelText="Closing Balance($)"
                            errorField={errors?.amount}
                          />
                        </Label>

                        <NumericFormat
                          type="text"
                          name="amount"
                          value={values?.amount}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          decimalScale={2}
                          allowNegative={false}
                          thousandSeparator={true}
                          autoComplete="off"
                          onKeyPress={(e) => {
                            e.which === 13 && e.preventDefault();
                          }}
                          className={
                            errors?.amount
                              ? `${cn(
                                  "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
                                )} focus-visible:ring-red-500 border-red-500`
                              : cn(
                                  "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
                                )
                          }
                        />
                      </div>
                    </div>
                    <div className="modal-footer pt-4 border-t mt-4 flex items-center justify-center">
                      <Button type="submit">Save</Button>
                      <Button
                        className="ml-3"
                        variant="secondary"
                        onClick={(e) => {
                          e?.preventDefault();
                          toggleEditModal();
                        }}
                      >
                        Cancel
                      </Button>
                    </div>
                  </form>
                </>
              );
            }}
          </Formik>
        </ResponsiveDrawerForm>
      </MainBody>
    </div>
  );
};

export default MonthlyBankReconciliation;
